<template>
    <div>
    	<img src="../assets/img/detail/sw/1.jpg" width="100%" />
    	<img src="../assets/img/detail/sw/2.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/3.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/4.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/5.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/6.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/7.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/8.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/9.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/10.jpg" width="100%"/>
    	<img src="../assets/img/detail/sw/11.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>